import React, { createContext } from "react";

export const Store = createContext(null);
